export default {
    "landing.nav.pricing": "Pricing",
    "landing.nav.login": "Login",
    "landing.nav.start": "Get Started",

    "landing.hero.badge": "The #1 tool for your citizenship",
    "landing.promo.badge": "💝 Month of Love Special: -30% with code LOVE30",
    "landing.hero.title": "Pass your citizenship exam on the first try",
    "landing.hero.title_gradient": "first try",
    "landing.hero.description": "Master the official guide with our adaptive quizzes, smart flashcards, audio summaries, and the Discover Canada book in EPUB format. The most effective way to become Canadian.",
    "landing.hero.cta.free": "Try for free",
    "landing.hero.cta.install": "Install app",
    "landing.hero.cta.discover": "Discover CitoyenPro",

    "landing.stats.questions": "Real questions",
    "landing.stats.success": "Success rate",
    "landing.stats.audio": "Audio summaries",
    "landing.stats.access": "Unlimited access",

    "landing.features.title": "Everything you need to succeed",
    "landing.features.description": "A complete suite of learning tools designed to save you time and maximize your retention.",

    "landing.features.flashcards.title": "Smart Flashcards",
    "landing.features.flashcards.desc": "Use spaced repetition to memorize historical dates and facts effortlessly.",
    "landing.features.quiz.title": "Thematic Quizzes",
    "landing.features.quiz.desc": "Practice chapter by chapter and instantly identify your weak points.",
    "landing.features.audio.title": "Audio Summaries",
    "landing.features.audio.desc": "Listen to the essential guide during your commute or daily activities.",
    "landing.features.exam.title": "Mock Exams",
    "landing.features.exam.desc": "Simulate real conditions with a timer and 20 random questions.",
    "landing.features.stats.title": "Progress Tracking",
    "landing.features.stats.desc": "Visualize your evolution with detailed charts on your accuracy.",
    "landing.features.gamification.title": "Challenges & Badges",
    "landing.features.gamification.desc": "Stay motivated by unlocking achievements and maintaining your daily streak.",
    "landing.features.epub.title": "Discover Canada Book",
    "landing.features.epub.desc": "Read the official guide directly in the app in EPUB format, free and unlimited.",
    "landing.features.epub.badge": "Free",

    "landing.gamification.badge": "Fun Learning",
    "landing.gamification.title": "Learn while having fun",
    "landing.gamification.description": "CitoyenPro turns revision into an engaging experience. Take on challenges, earn badges, and join thousands of motivated future citizens.",
    "landing.gamification.item1.title": "Achievement Badges",
    "landing.gamification.item1.desc": "Collect unique badges by completing themes and achieving perfect quizzes.",
    "landing.gamification.item2.title": "Daily Streak",
    "landing.gamification.item2.desc": "Maintain your daily study pace to reinforce your long-term memorization.",
    "landing.gamification.item3.title": "Progress Dashboard",
    "landing.gamification.item3.desc": "Track your overall score and see how well you are preparing for the big day.",
    "landing.gamification.mockup.streak": "7-day streak",
    "landing.gamification.mockup.scan": "Scan to install",

    "landing.testimonials.title": "They became Canadians with us",
    "landing.testimonials.description": "Discover testimonials from those who passed their exam using the CitoyenPro method.",
    "landing.testimonials.item1.name": "Maria Silva",
    "landing.testimonials.item1.role": "New Citizen (Toronto)",
    "landing.testimonials.item1.quote": "The audio summaries changed everything! I could review on the subway every morning. Result: 20/20 on the exam.",
    "landing.testimonials.item2.name": "Ahmed Mansour",
    "landing.testimonials.item2.role": "Future Citizen (Montreal)",
    "landing.testimonials.item2.quote": "The quizzes are very close to the real questions. It gave me incredible confidence for the big day.",
    "landing.testimonials.item3.name": "Li Wei Tan",
    "landing.testimonials.item3.role": "New Citizen (Vancouver)",
    "landing.testimonials.item3.quote": "The interface is super intuitive. You really see your progress evolve, which is very motivating.",

    "landing.cta.title": "Your journey to citizenship starts here",
    "landing.cta.description": "Join CitoyenPro today and give yourself the best chance to succeed in your integration into Canada.",
    "landing.cta.free": "Start for free",
    "landing.cta.pricing": "View pricing",

    "landing.pwa.badge": "Mobile Application",
    "landing.pwa.title": "CitoyenPro on your phone",
    "landing.pwa.description": "Install CitoyenPro instantly on your home screen without going through the stores. Fast, smooth, and efficient access.",
    "landing.pwa.step1.title": "Open the menu",
    "landing.pwa.step1.desc": "Tap 'Share' on iOS or the Chrome menu on Android.",
    "landing.pwa.step2.title": "Add to screen",
    "landing.pwa.step2.desc": "Select 'Add to Home Screen' to install the application.",
    "landing.pwa.direct": "Direct Installation",
    "landing.pwa.fast": "No App Store needed",

    "landing.footer.description": "The reference platform for preparing your Canadian citizenship exam successfully.",
    "landing.footer.social": "Follow us",
    "landing.footer.product": "Product",
    "landing.footer.product.features": "Features",
    "landing.footer.resources": "Resources",
    "landing.footer.resources.guide": "Study Guide",
    "landing.footer.resources.help": "Help & Support",
    "landing.footer.resources.news": "What's New",
    "landing.footer.resources.contact": "Contact",
    "landing.footer.legal": "Legal",
    "landing.footer.legal.privacy": "Privacy",
    "landing.footer.legal.terms": "Terms",
    "landing.footer.legal.notices": "Legal Notices",
    "landing.footer.copyright": "© 2025 CitoyenPro. All rights reserved."
};
